/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useResponsive } from '@/hooks';
import { usePathname } from '@/providers';
import { useMainLayout } from '@/layouts/main';
import { MegaMenuInner, MegaMenuInnerReferral } from '.';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useAuthContext } from '@/auth';
import { GTranslate } from '@/i18n';

const MegaMenu = () => {
  const desktopMode = useResponsive('up', 'lg');
  const { pathname, prevPathname } = usePathname();
  const { mobileMegaMenuOpen, setMobileMegaMenuOpen } = useMainLayout();
  const {auth, loading} = useAuthContext();
  const isReferralUser = auth?.user?.referral_attorney === 0;
  
  const handleDrawerClose = () => {
    setMobileMegaMenuOpen(false);
  };
  useEffect(() => {
    // Hide drawer on route chnage after menu link click
    if (desktopMode === false && prevPathname !== pathname) {
      handleDrawerClose();
    }
  }, [desktopMode, pathname, prevPathname]);
  if (desktopMode) {
    return isReferralUser ? <MegaMenuInner /> : <MegaMenuInnerReferral />;
  } else {
    return <Sheet open={mobileMegaMenuOpen} onOpenChange={handleDrawerClose}>
        <SheetContent className="border-0 p-0 w-[225px] scrollable-y-auto" forceMount={true} side="left" close={false}>
          <SheetHeader className="sr-only">
            <SheetTitle>Mobile Menu</SheetTitle>
            <SheetDescription></SheetDescription>
          </SheetHeader>
          {/* Mobile home for the language picker — it doesn't fit the phone header.
              This branch only renders below lg, which is exactly when HeaderTopbar
              drops its copy, so #google_translate_element stays unique. */}
          <div className="public-lang-switcher attorney-lang px-4 pt-4 pb-3 border-b border-gray-200">
            <GTranslate />
          </div>
          <MegaMenuInner />
        </SheetContent>
      </Sheet>;
  }
};
export { MegaMenu };